<template>
  <div class="online-renewal-terms-and-conditions">
    <v-container>
      <v-layout row wrap>
        <v-flex md6>
          <button class="transparent-button" @click="goBack()">
            <IconBase>
              <IconArrowBack />
            </IconBase>&nbsp;&nbsp;BACK
          </button>
        </v-flex>
      </v-layout>
      <div v-if="!$store.state.termsAndConditionsAccepted">
        <v-layout row wrap>
          <v-flex md6 offset-md3>
            <center>
              <h1 class="question-title">Terms &amp; Conditions</h1>
              <p class="question-content">Please check your payment and agree to any terms and conditions below, before proceeding to checkout.</p>
            </center>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md4 offset-md4>
            <h4>Purchase</h4>
            <br />
            <div class="tnc-table">
              <v-layout row wrap>
                <v-flex md6>Product:</v-flex>
                <v-flex md6>12m (PL/PA) insurance + annual membership</v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex md6>Payment Method:</v-flex>
                <v-flex md6>{{paymentMethod}}</v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex md6>AMOUNT DUE:</v-flex>
                <v-flex md6>${{totalPayable}}</v-flex>
              </v-layout>
            </div>
            <br />
            <h4>Terms &amp; Conditions</h4>
            <br />
            <div class="tnc-content">
              <h4>YOUR DUTY OF DISCLOSURE</h4>
              <p>Before you enter into an insurance contract, you have a duty to tell us anything that you know, or could reasonably be expected to know, may affect our decision to insure you and on what terms. You have this duty until we agree to insure you. You have the same duty before you renew, extend, vary or reinstate an insurance contract. You do not need to tell us anything that:</p>
              <ul>
                <li>reduces the risk we insure you for; or</li>
                <li>is common knowledge; or</li>
                <li>we know or should know as an insurer; or</li>
                <li>we waive your duty to tell us about</li>
              </ul>
              <p>
                If you do not tell us anything you are required to, we may cancel your contract or reduce the amount we will pay you if you make a claim, or both. If your failure to tell us is fraudulent, we may refuse to pay a claim and treat the contract as if it never existed.
                By paying the premium of this policy I declare that I have read and understood the duty of disclosure notice and the terms and conditions outlined in the Financial Services Guide (FSG). I confirm that I am aware that if I cancel this policy midterm, only the public liability and personal accident premium are refundable. I also declare that I am not aware of any claims/circumstances which could give rise to a claim or any impending infringement notice or fine under the Education and Care Services National Law or any other relevant Act, or any other matter which may affect your decision to insure me.
                Under the FDCA Privacy Policy we advise that we may provide your insurance status to the approved service that you are registered with as well as to the relevant Regulatory Authority (including providing your certificate of insurance if requested). Please refer to our FSG for our complete Privacy Statement.
                If you are aware of any claim/circumstances, impending infringement notice or fine, or any other matter which may affect our decision to insure you, you must call us on 1800 658 699 and disclose the details as your insurance may not be valid.
              </p>
            </div>
            <br />
            <center>
              <p>
                By clicking
                <strong>'Accept and Continue'</strong>, you agree to be bound by the terms and conditions of the policy.
              </p>
            </center>
            <br />
            <button class="green-button" id="accept_continue" @click="acceptTermsAndConditions()">
              <span>
              Accept and Continue&nbsp;
              <IconBase>
                <IconArrowForward />
              </IconBase>
              </span>
              <span v-if="loadingIcon">
                 <v-progress-circular
                  indeterminate
                  color="primary"
                ></v-progress-circular>
              </span>
            </button>
          </v-flex>
        </v-layout>
      </div>
      <div v-if="$store.state.termsAndConditionsAccepted && paymentTerms === 'annual'" key="NewBusinessPaymentStripe">
        <NewBusinessPayment
          :payment-terms="$store.state.NewBusinessPaymentTerms"
          :total-payable="totalPayable"
          :quote-id="quoteID"
        />
      </div>
      <div v-else-if="$store.state.termsAndConditionsAccepted && paymentTerms !== 'annual'" key="NewBusinessPaymentElantis">
        <div class="text-center">
          <h3>You are being redirected, please wait . . .</h3>
          <p>If you haven't been redirected in 30 seconds, click this button</p>
          <v-btn dark depressed large round color="green"> Continue </v-btn>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>

import NewBusinessPayment from "@/components/purchase_policy/NewBusinessPayment.vue";
import { capitalizedObjectKeys, trimObjValues } from "@/assets/scripts/utils";
import { IAddress } from "@/models/Address";

export default {
  components: {
    NewBusinessPayment
  },
  name: "PurchasePolicyTermsAndConditions",
  data() {
    return {
      paymentTerms: "",
      paymentMethod: "",
      installments: {
        annual: "12",
        monthly: "12",
        fortnightly: "24"
      },
      frequency: {
        annual: "M",
        monthly: "M",
        fortnightly: "F"
      },
      totalPayable: "0",
      totalPayableBase: "0",
      quoteID: "",
      loadingIcon : false,
      elantisErrorCount: 0
    };
  },
  computed: {
    sessionID(){
      let sessionID = this.$store.getters.getState("sessionDetails.id");
      return !!sessionID ? sessionID : localStorage.getItem("session_id");
    },
    userID(){
      let userID = this.$store.getters.getState("userId");
      return !!userID ? userID : localStorage.getItem("user_id");
    },
    companyID(){
      /**
       * @todo trigger SF create-update contact and company upon clicking of aggreement
       * @description current setup is looking on either the vuex store or localStorage 
       */
      let companyID = this.$store.getters.getState("companyId");
      return !!companyID ? companyID : localStorage.getItem("payment_terms");
    },
  },
  methods: {
    getPaymentMethod() {
      if (this.$store.state.sessionDetails){
        this.paymentTerms = this.$store.state.sessionDetails.properties.payment_terms;
        if (this.paymentTerms === 'annual') {
          this.paymentMethod = 'Credit Card';
          return
        } else if(['monthly', 'fortnightly'].some(i => i === this.paymentTerms)) {
          this.paymentMethod = 'Elantis';
          return
        }
      }
      Swal.fire({
        type: 'error',
        title: 'Authentication Error',
        text: 'Payment Term not found',
      }).then(result => this.$router.push('/purchase-policy'));
    },
    goBack(){
      const terms = this.$store.state.termsAndConditionsAccepted
      if(!!terms){
        this.$store.state.termsAndConditionsAccepted = !this.$store.state.termsAndConditionsAccepted
      } else {
        this.$router.push("/purchase-policy")
      }
    },
    async initPayment() {
      if (!!this.sessionID) {
        await this.getSessionByID();
      } else {
        this.$router.push("/purchase-policy");
      }
    },
    async getCompanyDetails(){
      return await this.$store
        .dispatch("fetchData", { method: "get", url: `/api/fdca/cfw/company/get_by_id.json`, data: { id: this.companyID }})
        .then(async ({data}) => {
            this.$store.commit("mutate",{ property: "companyDetails", value: data["items"]["results"][0] })
        })
        .catch(error => this.promptError(error));
    },
    async getSessionByID() {
      return await this.$store
        .dispatch("fetchData", { method: "get", url: `/api/fdca/cfw/sessions/get_by_id.json`, params: { id: this.sessionID }})
        .then(async ({data}) => {
            this.$store.commit("mutate",{ property: "sessionDetails", value: data["items"]["results"][0] });
            this.getPaymentMethod();
            await this.getQuoteBySessionID();

        }).catch(error => this.promptError(error));
    },
    async getQuoteBySessionID() {
      return await this.$store
        .dispatch("fetchData", { method: "get", url: `/api/fdca/cfw/quotes/get_by_session_id.json`, params: { session_id: this.sessionID } })
        .then(({ data }) => { 
            this.$store.commit("mutate", {
                property: "quoteDetails",
                value: data["items"]["results"][0]
              }
            )
            this.totalPayable = (data["items"]["results"][0]["properties"]["policy_premium_total"] / 100).toFixed(2); 

            if (this.paymentMethod === 'Elantis'){
              let interest = Number(this.totalPayable) / 10;
              this.totalPayable = (Number(this.totalPayable) + interest).toFixed(2);
            }

            this.quoteID = data["items"]["results"][0]["id"];
            this.getCompanyDetails()
        })
        .catch(error => this.promptError(error));
    },
    promptError(error) {
      console.error(error);
    },
    getMailingAddress(){
      //sample: addresses: "[{"id":"-1","type":"address","is_risk_address":true,"is_mailing_address":true,"address":{"address1":"123 Eagle Street ","address2":"","suburb":"Brisbane City ","postcode":"4000","state":"QLD"}}]"

      let address = JSON.parse(this.$store.state.sessionDetails.properties.addresses);
      let return_address;
      for(let i=0;i<address.length;i++){
        if(address[i].is_mailing_address == true){
          return_address = address[i].address;
          break; 
        }
      }
      return return_address;
    },
    async acceptTermsAndConditions() {

      document.getElementById("accept_continue").setAttribute("disabled", "true");
      this.loadingIcon = true;

      

      //check if user exist
      let getCustomerIfExist = await this.$store.dispatch("fetchData", {
          method: "get",
          url: `main/get_customer_by_email.json?email=` + encodeURI(this.$store.state.sessionDetails.properties.email) ,
      });

      //for create-user-company step function
      let user_id = getCustomerIfExist.data.items.total_entries > 0 ? getCustomerIfExist.data.items.results[0].id : "";
      let mailing_address_temp = this.getMailingAddress();
      let mailing_address = mailing_address_temp ? mailing_address_temp : {}; 
      let details = this.$store.state.sessionDetails.properties;

      let getCompanyIfExist;
      //check if company exist
      if(user_id){
        getCompanyIfExist = await this.$store.dispatch("fetchData", {
          method: "get",
          url: `main/get_company_by_user_id.json?user_id=`+ user_id,
        });
      }
      
      let company_id =  getCompanyIfExist ? getCompanyIfExist.data.items.results[0].customer[0].company.id : "";
      
      let registeredService = JSON.parse(details.registered_service);
      let createCRMPayload = {
        env: this.getInstanceEnvironment(),
        company: {
            id: company_id ? company_id : "",
            company_name: details.business_name,
            assigned_to: "",
            is_enabled: "true",
            service: details.registered_service,
            acecqa_id: registeredService.id,
            type: details.user_type,
            membership_number: "",
            home_phone_number: details.home_phone_number,
            company_email: details.email,
            mobile_phone_number: details.mobile_phone_number,
            mailing_address: mailing_address,
            rbn: details.abn
        },
        customer: {
            id: user_id,
            first_name: details.first_name,
            last_name: details.last_name,
            name: details.insured_name,
            email: details.email,
            date_of_birth: details.date_of_birth,
            contact_status: "",
            membership_expiry: "",
            membership_type: ""
        },
        user_type: details.user_type
      };

      let addUpdateCRM = await this.$store.dispatch("fetchData", {
          method: "post",
          url: `utilities/create_update_contact_company.json` ,
          data: createCRMPayload
      });

      let executionArn = {
        executionArn : addUpdateCRM.data.executionArn
      };

      let maxRetry = 10;
      let retries = 0;
      let interval = setInterval(async () => {
        retries++;
        let get_create_company_and_user_response_result = 
          await this.$store.dispatch("fetchData", {
            method: "post",
            url: `utilities/get_step_function_response.json`,
            data: executionArn
          });
          
        if (get_create_company_and_user_response_result.data.status === 200) {

          this.$store.commit('mutate', {
            property: "userID",
            value: user_id
          });

          this.$store.commit('mutate', {
            property: "sessionDetails.properties.user_id",
            value: get_create_company_and_user_response_result.data.data.customer.id
          });

          this.$store.commit('mutate', {
            property: "sessionDetails.properties.company_id",
            value: get_create_company_and_user_response_result.data.data.company.id
          });

          let policy_no_reference_point = 272437,
            policy_no_new_policy_base_padding = 2000000,
            policy_no_session_id = Number(this.$store.state.sessionDetails.id),
            policy_no = ((policy_no_new_policy_base_padding - policy_no_reference_point) + policy_no_session_id).toString();

          let payload = {
            id: this.$store.state.sessionDetails.id,
            user_id: this.$store.state.sessionDetails.properties.user_id,
            properties: {
              company_id: this.$store.state.sessionDetails.properties.company_id,
              policy_no: policy_no
            }
          }

          let updateSessionData = await serviceModule.session.updateSession(payload);

          clearInterval(interval);
          if (this.paymentMethod === "Elantis") {
            await this.promptElantisWarning()
          } else {
            await this.$store.dispatch("fetchData", {
              method: location.origin === "http://localhost:8080" ? "get" : "put",
              url: `/api/fdca/cfw/sessions/update_session_status.json`,
              data: {
                id: this.$store.state.sessionDetails.id,
                session_status: "locked",
              }
            });
            this.$store.commit("mutate", { property: "termsAndConditionsAccepted", value: true });
          }
        } else if (/*get_create_company_and_user_response_result.data.status === 500 ||*/ retries === maxRetry){
          clearInterval(interval);
          Swal.fire({
            title: 'Failed to Connect to the Server',
            text: "Please try again or contact the site administrator.",
            confirmButtonColor: '#1E86E3',
            confirmButtonText: 'OK'
          });
        }

      }, 4000);
    },
    createClientPayload(sessionProperties) {
        let riskAddress = JSON.parse(sessionProperties.insured_address),
          mailingAddress = (this.$store.state.companyDetails.fdca_address.length > 0) 
          ? this.$store.state.companyDetails.fdca_address[0].properties 
          : null

        return {
          "Name": sessionProperties.user_type === "service" 
            ? registeredService.service_name 
            : `${sessionProperties.first_name} ${sessionProperties.last_name}`,
          "Abn": sessionProperties.abn,
          "BrokerID": "",
          "UniqueClientId": sessionProperties.policy_no,
          "PostalAddress": {
            "Address1": riskAddress.address1,
            "Suburb": riskAddress.suburb,
            "State": riskAddress.state,
            "Postcode": riskAddress.postcode
          },
          "StreetAddress": trimObjValues(capitalizedObjectKeys(!!riskAddress 
            ? (new IAddress(
                riskAddress.address1,
                undefined,
                riskAddress.suburb,
                riskAddress.postcode,
                riskAddress.state))
            : (new IAddress()))),
          "Email": sessionProperties.email,
          "FSRAType": "FAMILYDA",
          "Contact": {
            "Name": `${sessionProperties.first_name} ${sessionProperties.last_name}`,
            "Mobile": sessionProperties.mobile_phone_number,
            // "Landline": sessionProperties.home_phone_number,
            "Email": sessionProperties.email
          },
          "AccountManager": {
            "Name": "Memberservices",
            "BrokerID": "BD",
            "Telephone": "02 4320 1126",
            "Email": "memberservices@fdca.com.au"
          }
        }
    },
    createPolicyPayload(sessionProperties, quoteProperties){
      return {
        "PolicyNumber": sessionProperties.policy_no,
        "InvoiceNumber": "",
        "BrokerID": "312480",
        "BrokerPolicyID": "312480",
        "Class": sessionProperties.user_type === "educator" ? "EDU" : "SERV",
        "Underwriter": {
          "Name": "LLOYDS",
          "BrokerID": "LLOYDS"
        },
        "TransactionType": sessionProperties.transaction_type.charAt(0).toUpperCase() + sessionProperties.transaction_type.substring(1),
        "InceptionDate": sessionProperties.policy_start,
        "ExpiryDate": sessionProperties.policy_expiry,
        "NetAmount": (quoteProperties.policy_premium_total / 100).toFixed(2).toString(),
        "Amount": (quoteProperties.policy_premium_total / 100).toFixed(2).toString(),
        "FSRAType": "FAMILYDA"
      }
    },
    createLogonDetails(){
      return {
        "Funder": "FUNDCO",
        "LedgerID": "L:8c5c7c34-11bc-7049-98a9-a9272d5651c3",
        "Online": "Y",
        "Broker": {
          "ABN": "1",
          "Name": "yyy",
          "Telephone": "1",
          "Fax": "",
          "Email": "test@abc.com.au",
          "Contact": {
            "Name": "xxx",
            "Telephone": "1",
            "Mobile": "1",
            "Fax": "",
            "Email": "memberservices@fdca.com.au",
            "Loginid": "memberservices"
          }
        },
        "Software": {
          "Company": "Ebix Australia Pty Ltd",
          "Name": "WinBEAT",
          "Version": "4.0.66"
        }
      }
    },
    createElantisPayload() {
      let 
        sessionProperties = this.$store.state.sessionDetails.properties,
        quoteProperties = this.$store.state.quoteDetails.properties,
        registeredService = sessionProperties.registered_service ? JSON.parse(sessionProperties.registered_service) : {};

      return {
        "query": {
          "user_id": sessionProperties.user_id,
          "session_id": this.sessionID,
          "env": this.getInstanceEnvironment(),
          "transaction_api_token": serviceModule.transactionsToken(),
        },
        "payload": {
          "newQuoteDetails": {
            "ReturnUrl": `${this.baseURL}/#/purchase-policy/success`,
            "Client": this.createClientPayload(sessionProperties),
            "Policies": {
              "Policy": this.createPolicyPayload(sessionProperties, quoteProperties)
            },
            "Instalments": this.installments[this.paymentTerms],
            "ContractDetails": {
              "PaymentFrequency": this.frequency[this.paymentTerms]
            }
          },
          "logonDetails": this.createLogonDetails()
        }
      }
    },
    getInstanceEnvironment() {
        let curr = ""
        switch (window.location.origin) {
            case 'https://fda-insurance-production-0.prod01.sydney.platformos.com':
            case 'https://fda-insurance.prod01.sydney.platformos.com':
            case 'https://insurance.familydaycare.com.au':
                curr = 'prod';
                break;
            default:
              return 'staging';
        }
        
        return curr;
    },
    async promptElantisWarning(){
      Swal.fire({
        title: 'Elantis Application',
        icon: 'warning',
        text: "This page will be redirected to the Elantis Application page. Please do not close the window after you have submitted the form. The page will be automatically redirected to our site to complete the purchase policy flow.",
        confirmButtonColor: '#1E86E3',
        confirmButtonText: 'Proceed to Elantis'
      }).then(async (result) => {
        this.$store.commit("mutate", { property: "termsAndConditionsAccepted", value: true });
        await this.proceedToElantis()
      })
    },
    async proceedToElantis() {
            let payload = {
                method: 'post',
                url: `${this.baseURL}/api/fdca/cfw/payment/add/elantis.json`,
                data: this.createElantisPayload()
            };
            this.$store.dispatch('fetchData', payload)
            .then(response => {
                if(response.data.statusCode == 200) {
                    window.location.href = response.data.body.paperlessURL;
                } else {
                    this.proceedingToElantis = false;
                    Swal.fire({
                        type: 'error',
                        title: 'Error',
                        text: 'A problem was encountered with elantis.'
                    })
                }
            }).catch(error => {
              this.elantisErrorCount++
              this.proceedingToElantis = false;
              let message
              if(this.elantisErrorCount < 5) {
                message = 'A problem was encountered with elantis.'
              } else {
                message = 'Unfortunately we cannot process your application at this time, please contact FDCA on 1800 658 699'
              }
                Swal.fire({
                    type: 'error',
                    title: 'Error',
                    text: message
                })
            })
        },
  },
  mounted() {
    this.initPayment();
    this.paymentTerms = this.$store.state.sessionDetails.properties.payment_terms;
  }
};
</script>

<style lang="css" scoped>
.online-renewal-terms-and-conditions {
  background-color: white;
  min-height: 64vh;
}
.question-title {
  color: #d93b20;
  font-weight: bolder;
  margin-bottom: 20px;
}
.question-content {
  margin-bottom: 50px;
}
.blue-button:first-child {
  float: right;
}
.blue-button:last-child {
  float: left;
}
.nsw-text {
  background-color: #58b7dd;
  border-radius: 5pt;
  color: white;
  display: flex;
  align-items: center;
  padding: 10px 20px;
}
.nsw-text div:nth-child(2) {
  padding-left: 20px;
}
.icon-circle-wrapper {
  background-color: white;
  border-radius: 100%;
  color: #58b7dd;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
}
.icon-circle-wrapper .icon {
  height: 25px;
  width: 25px;
}
.tnc-table {
  box-sizing: border-box;
  border-radius: 4px;
  -webkit-box-shadow: 0 0 1px 1px #b6bdc2 inset;
  -moz-box-shadow: 0 0 1px 1px #b6bdc2 inset;
  box-shadow: 0 0 1px 1px #b6bdc2 inset;
}
.tnc-table > div {
  display: flex;
  align-items: center;
  justify-content: left;
  padding: 10px 20px;
  border-bottom: 1px solid #b6bdc2;
}
.tnc-table > div > div:first-child {
  color: #475b67;
}
.tnc-table > div > div:last-child {
  font-weight: bolder;
}
.tnc-content {
  background: #ffffff;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  padding: 20px;
  height: 300px;
  overflow-y: scroll;
}
.tnc-content::-webkit-scrollbar {
  width: 12px;
}
.tnc-content::-webkit-scrollbar-track {
  background: rgba(213, 213, 213, 0.2);
}
.tnc-content::-webkit-scrollbar-thumb {
  background-color: #d5d5d5;
  border-radius: 10px;
}
</style>